export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PYTHON_URL = process.env.REACT_APP_PYTHON_BASE_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const CRM_URL = process.env.REACT_APP_SLD_CRM_URL
export const BOOKS_URL = process.env.REACT_APP_SLD_BOOK_URL